import React from "react";
import {
  iPractitionerProfile,
  contactInfoSchema,
  practitionerApproachSchema,
  aboutPracticeSchema,
  qualificationsSchema,
  profileImagesSchema,
} from "ps-shared";
import { FormikWizard } from "src/components/Forms/FormikWizard";

import { ContactInfoForm } from "src/components/My/Profiles/Forms/Practitioner/ContactInfo";
import ProfileImages from "src/components/My/Profiles/Forms/ProfileImages";

import Qualifications from "src/components/My/Profiles/Forms/Practitioner/Qualifications";
import Approach from "src/components/My/Profiles/Forms/Practitioner/Approach";
import { navigate } from "gatsby";
import { ProfileManageMode } from "src/models/ProfileManageMode";
import { ProfileWizardCbData, ProfileWizardCbResult } from "src/components/My/Profiles/ProfileWizard";
import { toast } from "react-toastify";
import AboutPractice from "./Forms/Practitioner/AboutPractice";

interface PractitionerProfileWizardProps {
  profile: iPractitionerProfile;
  mode: ProfileManageMode;
  submitCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
  nextCb: (data: ProfileWizardCbData) => Promise<ProfileWizardCbResult>;
}
interface PractitionerProfileWizardState {
  formInit: any;
}

export class PractitionerProfileWizard extends React.Component<
  PractitionerProfileWizardProps,
  PractitionerProfileWizardState
> {
  private wizRef = React.createRef<FormikWizard>();

  constructor(props: PractitionerProfileWizardProps) {
    super(props);
    const mergedSchemas = contactInfoSchema
      .concat(profileImagesSchema)
      .concat(practitionerApproachSchema)
      .concat(aboutPracticeSchema)
      .concat(qualificationsSchema)
      .cast();
    if (this.props.mode === ProfileManageMode.edit) {
      // convert the server record to clinic profile
      Object.keys(this.props.profile).forEach((prop: string) => {
        // eslint-disable-next-line no-prototype-builtins
        if (this.props.profile[prop] !== undefined && mergedSchemas.hasOwnProperty(prop)) {
          (mergedSchemas as any)[prop] = this.props.profile[prop];
        }
      });
    }
    this.state = {
      formInit: mergedSchemas,
    };
  }

  public cancel() {
    navigate("/my/profiles/");
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormikWizard
          ref={this.wizRef}
          initialValues={this.state.formInit}
          validationSchemas={[
            contactInfoSchema,
            profileImagesSchema,
            aboutPracticeSchema,
            qualificationsSchema,
            practitionerApproachSchema,
          ]}
          mode={this.props.mode}
          onCancel={() => {
            this.cancel();
          }}
          onNext={(values: any, page: number): Promise<ProfileWizardCbResult> => {
            return new Promise((resolve, reject) => {
              this.props
                .nextCb({ values, page })
                .then((result) => {
                  return resolve(result);
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
          onSubmit={(values: any, page: number) => {
            return new Promise((resolve, reject) => {
              this.props
                .submitCb({ values, page })
                .then(() => {
                  resolve();
                })
                .catch((error: ProfileWizardCbResult) => {
                  if (error.errs) {
                    error.errs.forEach((e: string) => {
                      toast.error(e);
                    });
                  } else {
                    toast.error("Oops! Something bad happened, pls try again");
                  }
                  reject();
                });
            });
          }}
        >
          <FormikWizard.Page name="Contact Info">
            {(values: any) => <ContactInfoForm values={values} />}
          </FormikWizard.Page>
          <FormikWizard.Page name="Images">
            {(values: any) => (
              <div>
                <ProfileImages values={values} slug={values.slug} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="About your Practice">
            {(values: any) => (
              <div>
                <AboutPractice values={values} profile={this.props.profile} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Qualifications">
            {(values: any) => (
              <div>
                <Qualifications values={values} />
              </div>
            )}
          </FormikWizard.Page>
          <FormikWizard.Page name="Approach">{(values: any) => <Approach values={values} />}</FormikWizard.Page>
        </FormikWizard>
      </>
    );
  }
}
